import { createAsyncThunk } from "@reduxjs/toolkit";
import { getActivityService } from "./activity.service";
import { IActivityResponse } from "./activity.interface";

export const getActivities = createAsyncThunk<
  IActivityResponse[],
  void,
  { rejectValue: any }
>("activity/getActivities", async (_, { rejectWithValue }) => {
  try {
    const response = await getActivityService();
    return response;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});
